module.exports = __webpack_public_path__ + "static/media/thumbs-down.6479673b.svg";